const POSTAL_CODE_LENGTH = 8;
const PREFIX_LENGTH = 5;

/** Remove a máscara: só os 8 primeiros dígitos do CEP. */
export function unmaskPostalCode(value: string): string {
  return value.replace(/\D/g, '').slice(0, POSTAL_CODE_LENGTH);
}

/** Aplica a máscara `00000-000` progressivamente. */
export function maskPostalCode(value: string): string {
  const digits = unmaskPostalCode(value);
  return digits.length > PREFIX_LENGTH
    ? `${digits.slice(0, PREFIX_LENGTH)}-${digits.slice(PREFIX_LENGTH)}`
    : digits;
}
